module.exports = ".user-stats-column {\r\n    width: 33%;\r\n    float: left;\r\n}"